import { authFetch } from "../auth-context";
import { validArchive } from "./delegateTimeline";
import type { DelegateArchive, DelegateStatus } from "./types";
export type ArchivedDelegateRun = DelegateArchive & {status:DelegateStatus["status"]};
type Waiter = {requestMessageId:string;resolve:(runs:ArchivedDelegateRun[])=>void;reject:()=>void};
const pending = new Map<string,Waiter[]>();
/** Coalesce visible turns into one bounded indexed request, never one fetch per chat message. */
export function requestDelegateArchives(companyId:string, requestMessageId:string):Promise<ArchivedDelegateRun[]> {
  return new Promise((resolve,reject) => {
    const waiting = pending.get(companyId);
    if (waiting) waiting.push({requestMessageId,resolve,reject}); else {
      pending.set(companyId,[{requestMessageId,resolve,reject}]);
      setTimeout(() => void flush(companyId),0);
    }
  });
}
async function flush(companyId:string) {
  const waiting = pending.get(companyId) ?? []; pending.delete(companyId);
  const ids = [...new Set(waiting.map(item=>item.requestMessageId))];
  for(let offset=0;offset<ids.length;offset+=50) {
    const batchIds=ids.slice(offset,offset+50),group=waiting.filter(item=>batchIds.includes(item.requestMessageId));
    try {
      let cursor:string|undefined; const runs:ArchivedDelegateRun[]=[];
      do {
        const query=new URLSearchParams({requestMessageIds:JSON.stringify(batchIds)});
        if(cursor) query.set("cursor",cursor);
        const response=await authFetch("/api/sessions/"+encodeURIComponent(companyId)+"/delegate-runs?"+query);
        // Old frontends/backends may be deployed separately. No invented archive.
        if(!response.ok) throw new Error("Run index unavailable");
        const page=await response.json();
        if(!Array.isArray(page.runs)||page.runs.length>50) throw new Error("Invalid run index");
        for(const run of page.runs) if(validArchive(run)&&batchIds.includes(run.requestMessageId)&&
          ["waiting","running","verifying","completed","failed","cancelled"].includes(run.status)) runs.push(run);
        const next=typeof page.nextCursor==="string"&&page.nextCursor.length<=2048?page.nextCursor:undefined;
        if(!next||next===cursor) break; cursor=next;
      } while(cursor);
      for(const waiter of group) waiter.resolve(runs.filter(run=>run.requestMessageId===waiter.requestMessageId));
    } catch {for(const waiter of group) waiter.reject();}
  }
}
